import { c as _c } from "react/compiler-runtime";
import { ListingCard, ListingCardSkeleton } from "@/components/cards/listing-card";
import type { ListingCardProps } from "@/components/cards/listing-card";
import { DirectoryFeaturedRow } from "./directory-featured-row.component";
import type { ListingItem } from "./directory-listing.types";
interface DirectoryCardGridProps {
  items: ListingItem[];
  mapToCardProps: (item: ListingItem) => ListingCardProps;
  isPending: boolean;
  featuredFirstRow?: boolean;
}
const SKELETON_COUNT = 6;
const FEATURED_SIDE_COUNT = 2;
const subgridClasses = "col-span-full grid grid-cols-subgrid gap-x-4 gap-y-8 tablet:gap-x-6 desktop:gap-y-12";
export function DirectoryCardGrid(t0) {
  const $ = _c(18);
  const {
    items,
    mapToCardProps,
    isPending,
    featuredFirstRow: t1
  } = t0;
  const featuredFirstRow = t1 === undefined ? false : t1;
  if (isPending && items.length === 0) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className={subgridClasses}>{Array.from({
          length: SKELETON_COUNT
        }).map(_temp)}</div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (items.length === 0) {
    return null;
  }
  const showFeatured = featuredFirstRow && items.length > 0;
  const featured = showFeatured ? items[0] : null;
  let t2;
  if ($[1] !== items || $[2] !== showFeatured) {
    t2 = showFeatured ? items.slice(1, 1 + FEATURED_SIDE_COUNT) : [];
    $[1] = items;
    $[2] = showFeatured;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sideItems = t2;
  let t3;
  if ($[4] !== items || $[5] !== showFeatured || $[6] !== sideItems) {
    t3 = showFeatured ? items.slice(1 + sideItems.length) : items;
    $[4] = items;
    $[5] = showFeatured;
    $[6] = sideItems;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const remainingItems = t3;
  let t4;
  if ($[8] !== featured || $[9] !== mapToCardProps || $[10] !== sideItems) {
    t4 = featured && <DirectoryFeaturedRow featured={featured} side={sideItems} mapToCardProps={mapToCardProps} />;
    $[8] = featured;
    $[9] = mapToCardProps;
    $[10] = sideItems;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== mapToCardProps || $[13] !== remainingItems) {
    t5 = remainingItems.length > 0 && <div className={subgridClasses}>{remainingItems.map(item => <div key={item._id} className="col-span-4"><ListingCard {...mapToCardProps(item)} /></div>)}</div>;
    $[12] = mapToCardProps;
    $[13] = remainingItems;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp(_, i) {
  return <div key={i} className="col-span-4"><ListingCardSkeleton /></div>;
}